import { FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { BaseQueryFn, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ADMIN_ROUTES, WAREHOUSE_ROUTES } from '../../constants/routes';

console.log(`${process.env.NODE_ENV} => ${process.env.REACT_APP_API_URL}`);

const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8181';
const baseQuery = fetchBaseQuery({
  baseUrl,
  credentials: 'include',
  prepareHeaders: (headers) => {
    return headers;
  },
});

const requestQueue: (() => Promise<void>)[] = []; // Queue to store request functions
let isProcessing = false; // Flag to track if the queue is being processed

const processQueue = async () => {
  if (isProcessing) return;
  isProcessing = true;

  while (requestQueue.length > 0) {
    const request = requestQueue.shift();
    if (request) {
      try {
        await request();
      } catch (error) {
        console.error('Request in queue failed:', error);
      }
    }
  }

  isProcessing = false;
};

const baseQueryWithTokenManagement: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args: any,
  api,
  extraOptions
) => {
  const method = typeof args === 'string' ? 'GET' : args.method?.toUpperCase() || 'GET';

  if (method === 'GET sync') {
    return baseQuery(args, api, extraOptions);
  } else {
    return new Promise((resolve, reject) => {
      const request = async () => {
        const tokenKey = 'xsrfToken';
        const token = JSON.parse(localStorage.getItem(tokenKey) as string);

        const modifiedArgs =
          typeof args === 'string'
            ? { url: args, headers: {} as Record<string, string> }
            : { ...args, headers: { ...((args.headers || {}) as Record<string, string>) } };

        if (token && method !== 'GET' && args.url !== '/uaa/api/authenticate') {
          modifiedArgs.headers['X-XSRF-TOKEN'] = token;
        }

        try {
          const result: any = await baseQuery(modifiedArgs, api, extraOptions);
          const is_warehouse_user = window.location.pathname.includes('/warehouse');

          // Store the appropriate XSRF token based on user type
          if (result?.meta?.response?.headers?.get('X-XSRF-TOKEN')) {
            const newToken = result.meta.response.headers.get('X-XSRF-TOKEN');
            const storageKey = 'xsrfToken';
            localStorage.setItem(storageKey, JSON.stringify(newToken));
          }

          if (result?.error?.data?.error === 'deactivate_user') {
            if (is_warehouse_user) {
              window.location.href = WAREHOUSE_ROUTES.warehouseSignIn;
            } else {
              window.location.href = ADMIN_ROUTES.adminSignIn;
            }
            localStorage.clear();
            sessionStorage.clear();
          }

          if (result.error && result.error.status === 401) {
            if (is_warehouse_user) {
              window.location.href = WAREHOUSE_ROUTES.warehouseSignIn;
            } else {
              window.location.href = ADMIN_ROUTES.adminSignIn;
            }
            localStorage.clear();
            sessionStorage.clear();
          }

          resolve(result);
        } catch (error) {
          reject(error);
        }
      };

      requestQueue.push(request); // Add request to the queue
      processQueue(); // Start processing the queue
    });
  }
};

export default baseQueryWithTokenManagement;
